module.exports = __webpack_public_path__ + "media/assets/images/flags/vu-7861996732daf2f65c767400dfc848b9.svg";